import React, {Component} from 'react'
import Loading from '../Loading'
import utils from '../../utils/utils'
import ServerItem from './ServerItem'
import _ from 'lodash'
import { Collapse, Button, Container, Row, Col, Badge} from 'reactstrap';

export default class ZoneItem extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      collapse: true,
    }
    this.toggle = this.toggle.bind(this)
  }
  toggle() {
    this.setState({collapse: !this.state.collapse})
  }
  render(){
    const servers = []
    for (const server of this.props.servers) {
      if (!server.workers || !_.isArrayLike(server.workers)) {
        server.workers = []
      }
      servers.push(
        <ServerItem key={server.ip} server={server}/>
      )
    }
    return(
      <div className="panel panel-default mt5 mb5">
        <div className="panel-body">
        <Button key={this.props.zone} color="link" size="lg" onClick={this.toggle} block>
              <Container fluid={true}>
                <Row>
                  <Col sm='12'>
                  {utils.getCollapseArrow(this.state.collapse, 'mt2', 'left')}
                    <h3 className='pull-left zone-title'>
                    {this.props.zone.toUpperCase()} - Servers {' '}
                    <Badge color='primary' className='ms-badge'>
                    <span className='badget-zone-text'>{this.props.servers.length}</span>
                    </Badge>
                    </h3>
                  </Col>
                </Row>
              </Container>
        </Button>
        <Collapse isOpen={this.state.collapse}>
        {servers}
        </Collapse>
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/server/ZoneItem.js